import { Box, List } from "@mui/material";
import { SkillsListHeader } from "./Header/SkillsListHeader";
import { SkillsListEmpty } from "./SkillsListEmpty";
import { SkillsListItem } from "./SkillsListItem";
import { SkillsListLoading } from "./SkillsListLoading";
import type { SkillsListPanelProps } from "./types";

export const SkillsListPanel = ({
  skills,
  selectedSkillId,
  isLoading,
  filter,
  search,
  onFilterChange,
  onSearchChange,
  onCreateSkill,
  onUploadSkill,
  onSelectSkill,
}: SkillsListPanelProps) => (
  <Box
    sx={{
      height: "100%",
      minHeight: 0,
      minWidth: 0,
      bgcolor: "white",
      display: "flex",
      flexDirection: "column",
    }}
    data-testid="skills-list-panel-surface"
  >
    <SkillsListHeader
      filter={filter}
      search={search}
      onFilterChange={onFilterChange}
      onSearchChange={onSearchChange}
      onCreateSkill={onCreateSkill}
      onUploadSkill={onUploadSkill}
    />

    {isLoading ? (
      <SkillsListLoading />
    ) : (
      <List
        disablePadding
        sx={{ overflowY: "auto", minHeight: 0, p: 0 }}
        data-testid="skills-list"
      >
        {skills.map((skill) => (
          <SkillsListItem
            key={skill.id}
            skill={skill}
            selected={skill.id === selectedSkillId}
            onSelect={onSelectSkill}
          />
        ))}
        {!skills.length ? <SkillsListEmpty /> : null}
      </List>
    )}
  </Box>
);
